
export default {
    name:'LeeBadge',
    data() {
        return {
         styleObject:{
            background:this.color
         }
        }
    },
    props: {
        title: {
            type: String,
            default: '徽章名称' //默认default
        },
        info: {
            type: String,
            default: '0' //默认default
        },
        color: {
            type: String,
            default: '#f00' //默认default
        },
        href: {
            type: String,
            default: '' //默认default
        }
    }
};
